module.exports = "<div class=\"dropdown-item_name\" data-value=\"{{::option.Text}}\" dataclass=\"_optionText\" ng-bind-html=\"option.Text\"></div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/address/billing-address/billing-address-item-template.html
 ** module id = 886
 ** module chunks = 1
 **/